import { createSelector } from "reselect";
import { ROLE_TYPES } from "constants/users";
import { EMPTY_ARRAY } from "lib";
import { getActiveRole } from "./root";

export const getSelectableBranches = createSelector(
  [getActiveRole],
  activeRole => {
    if (activeRole.type === ROLE_TYPES.STOCK_AGENT) {
      return activeRole.agencies.reduce(
        (branches, agency) =>
          agency.branches && agency.branches.length > 0
            ? branches.concat(agency.branches)
            : branches,
        [],
      );
    }
    return EMPTY_ARRAY;
  },
);

export const hasBranches = createSelector(
  [getSelectableBranches],
  selectableBranches => selectableBranches.length > 0,
);
